 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"character-id~collects~commoditie-id~course-id~creation-id~login~orders~organizations~pay-commoditie-~06d159ad":"character-id~collects~commoditie-id~course-id~creation-id~login~orders~organizations~pay-commoditie-~06d159ad","character-id~collects~course-id~creation-id~lesson-id~login~orders~organizations~pay-commoditie-id~s~771b69ba":"character-id~collects~course-id~creation-id~lesson-id~login~orders~organizations~pay-commoditie-id~s~771b69ba","character-id":"character-id","collects":"collects","course-id":"course-id","creation-id~orders~pay-commoditie-id~studio-tools~vip-id":"creation-id~orders~pay-commoditie-id~studio-tools~vip-id","creation-id":"creation-id","orders":"orders","pay-commoditie-id":"pay-commoditie-id","studio-tools":"studio-tools","vip-id":"vip-id","login":"login","organizations":"organizations","studio-commodities":"studio-commodities","studio-teachers":"studio-teachers","teacher-courses":"teacher-courses","teacher-creation":"teacher-creation","teacher-home~teacher-layout":"teacher-home~teacher-layout","teacher-home":"teacher-home","teacher-layout":"teacher-layout","teacher-video":"teacher-video","video-id":"video-id","vip-related":"vip-related","commoditie-id":"commoditie-id","studio":"studio","studio-user":"studio-user","lesson-id":"lesson-id","index":"index","teacher":"teacher"}[chunkId]||chunkId) + "." + {"character-id~collects~commoditie-id~course-id~creation-id~login~orders~organizations~pay-commoditie-~06d159ad":"19636baf","character-id~collects~course-id~creation-id~lesson-id~login~orders~organizations~pay-commoditie-id~s~771b69ba":"21b8d9c9","character-id":"60dfd2f7","collects":"16cb4110","course-id":"a4e98cd5","creation-id~orders~pay-commoditie-id~studio-tools~vip-id":"e53d93b8","creation-id":"0fa3fa8e","orders":"efb4507d","pay-commoditie-id":"eebf0568","studio-tools":"ee838bb7","vip-id":"9cbf5f7b","login":"6945028e","organizations":"8b39a3c7","studio-commodities":"45cb44d2","studio-teachers":"3cfab033","teacher-courses":"dcaefe78","teacher-creation":"938d00c6","teacher-home~teacher-layout":"b06d72ba","teacher-home":"a1c5d0d7","teacher-layout":"547474a7","teacher-video":"93f9a7c5","video-id":"3b38f4df","vip-related":"8801922f","commoditie-id":"2a0f8551","studio":"c04eebf5","studio-user":"53be318f","lesson-id":"1a67d8d7","index":"8122dcbd","teacher":"a35a8b8b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"character-id~collects~course-id~creation-id~lesson-id~login~orders~organizations~pay-commoditie-id~s~771b69ba":1,"character-id":1,"collects":1,"course-id":1,"creation-id~orders~pay-commoditie-id~studio-tools~vip-id":1,"creation-id":1,"orders":1,"pay-commoditie-id":1,"studio-tools":1,"vip-id":1,"login":1,"organizations":1,"studio-commodities":1,"studio-teachers":1,"teacher-courses":1,"teacher-creation":1,"teacher-home~teacher-layout":1,"teacher-home":1,"teacher-layout":1,"teacher-video":1,"video-id":1,"vip-related":1,"commoditie-id":1,"studio":1,"studio-user":1,"lesson-id":1,"index":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"character-id~collects~commoditie-id~course-id~creation-id~login~orders~organizations~pay-commoditie-~06d159ad":"character-id~collects~commoditie-id~course-id~creation-id~login~orders~organizations~pay-commoditie-~06d159ad","character-id~collects~course-id~creation-id~lesson-id~login~orders~organizations~pay-commoditie-id~s~771b69ba":"character-id~collects~course-id~creation-id~lesson-id~login~orders~organizations~pay-commoditie-id~s~771b69ba","character-id":"character-id","collects":"collects","course-id":"course-id","creation-id~orders~pay-commoditie-id~studio-tools~vip-id":"creation-id~orders~pay-commoditie-id~studio-tools~vip-id","creation-id":"creation-id","orders":"orders","pay-commoditie-id":"pay-commoditie-id","studio-tools":"studio-tools","vip-id":"vip-id","login":"login","organizations":"organizations","studio-commodities":"studio-commodities","studio-teachers":"studio-teachers","teacher-courses":"teacher-courses","teacher-creation":"teacher-creation","teacher-home~teacher-layout":"teacher-home~teacher-layout","teacher-home":"teacher-home","teacher-layout":"teacher-layout","teacher-video":"teacher-video","video-id":"video-id","vip-related":"vip-related","commoditie-id":"commoditie-id","studio":"studio","studio-user":"studio-user","lesson-id":"lesson-id","index":"index","teacher":"teacher"}[chunkId]||chunkId) + "." + {"character-id~collects~commoditie-id~course-id~creation-id~login~orders~organizations~pay-commoditie-~06d159ad":"31d6cfe0","character-id~collects~course-id~creation-id~lesson-id~login~orders~organizations~pay-commoditie-id~s~771b69ba":"4785547a","character-id":"94e85495","collects":"90df42d8","course-id":"5475128c","creation-id~orders~pay-commoditie-id~studio-tools~vip-id":"86a2da62","creation-id":"b1d92e15","orders":"2f85df44","pay-commoditie-id":"ea81a921","studio-tools":"fd30184f","vip-id":"c859c403","login":"f692e727","organizations":"91d06de0","studio-commodities":"292b7210","studio-teachers":"ccfa74dc","teacher-courses":"2c80cbfc","teacher-creation":"fe0f5157","teacher-home~teacher-layout":"22eb5139","teacher-home":"e5ae30ec","teacher-layout":"0cbf27ab","teacher-video":"a7cca3a9","video-id":"28afbe93","vip-related":"f9e061a1","commoditie-id":"9ddb8681","studio":"431aad26","studio-user":"d4d34b03","lesson-id":"3be7534b","index":"293ba0f0","teacher":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/stu/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
